<template>
    <div v-if="supported" class="embed">
        <iframe
            :id="id"
            class="embed-frame"
            :title="frameTitle"
            type="text/html"
            width="100%"
            frameborder="0"
            scrolling="no"
            allowfullscreen="true"
            allow="clipboard-write; encrypted-media; picture-in-picture; web-share"
            :src="src"
        />
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { EMBED_SERVICES } from '@model/editor-js/blocks';
import type { BodyVariant, EmbedData } from '@model/editor-js/blocks';

defineOptions({
    name: 'BlockEmbed',
});

const props = defineProps<{
    id?: string;
    data: EmbedData;
    variant: BodyVariant;
}>();

// legacy content still holds services the site cannot embed (slideshare, wistia, …); they are being fixed in the CMS
const supported = (EMBED_SERVICES as readonly string[]).includes(props.data.service);
if (!supported) {
    // eslint-disable-next-line no-console
    console.warn(`[body-renderer] embed service "${props.data.service}" is not supported, block ${props.id ?? ''} is not rendered`);
}

const src = computed(() => (props.data.service === 'youtube'
    ? `https://www.youtube.com/embed/${props.data.id}?modestbranding=1`
    : props.data.iframeUrl));

const frameTitle = computed(() => (props.data.service === 'youtube' ? 'YouTube video' : 'Embedded content'));
</script>

<style lang="pcss" scoped>
.body-renderer .embed {
    margin-bottom: 40px;
}

.body-renderer .embed-frame {
    border: 0;
    aspect-ratio: 16/9;
}
</style>
